import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=754012f3&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=754012f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754012f3",
  null
  
)

export default component.exports
import {QCard,QCardSection,QSelect,QSeparator,QIcon,QInnerLoading,QSpinner,QTooltip} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSelect,QSeparator,QIcon,QInnerLoading,QSpinner,QTooltip})
